import bgImg from '../assets/images/bgImg.jpg';

import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa';

export default function Main() {
  return (
    <main
      style={{ backgroundImage: `url(${bgImg})` }}
      className='relative h-screen w-screen p-8 flex flex-col gap-4 justify-between items-center bg-cover bg-center text-white'
    >
      <div className='absolute inset-[0] bg-black bg-opacity-70'></div>
      <section className='z-50 relative w-full mt-6 flex flex-col items-center text-[#E7D3A0] font-bold capitalize tracking-[.5rem]'>
        <h1 className='text-6xl'>Clif</h1>
        <h1 className='text-sm'>Creations</h1>
        <div className='absolute bottom-[-.25rem] left-1/2 translate-x-[-50%] w-[5rem] h-[.125rem] bg-[#9F5A4C] rounded-full'></div>
      </section>
      <section className='z-50 flex flex-col gap-2 justify-center items-start font-medium uppercase'>
        <h3 className='text-4xl '>cv | cover letter</h3>
        <h4 className='text-xl font-light'>
          you want to be hired,
          <br />
          and be on top of all job
          <br />
          seekers?
        </h4>
        <p>
          you just need to
          <a
            href='mailto:clfajak@gmail.com?subject=Clif Creations'
            target='_blank'
            rel='noopener noreferrer'
            className='ml-2 px-3 py-2 bg-[#9F5A4C] text-sm font-bold border-2 border-white rounded-3xl hover:bg-[#E7D3A0] focus:bg-[#E7D3A0] hover:text-[#9F5A4C] focus:text-[#9F5A4C]'
          >
            contact me
          </a>
        </p>
      </section>
      <section className='z-50 mb-8 w-full flex justify-center items-center md:mb-0'>
        <div className='w-full flex justify-center items-center gap-8 text-2xl'>
          <a href='/' target='_blank' rel='noopener noreferrer'>
            <FaInstagram />
          </a>
          <a
            href='https://www.facebook.com/CLIF-Creations-113899524630417/'
            target='_blank'
            rel='noopener noreferrer'
          >
            <FaFacebookF />
          </a>
          <a
            href='https://wa.me/249968590953'
            target='_blank'
            rel='noopener noreferrer'
          >
            <FaWhatsapp />
          </a>
        </div>
      </section>
    </main>
  );
}
